import * as log from "loglevel"
log.setDefaultLevel(process.env.NODE_ENV === "production" ? log.levels.WARN : log.levels.TRACE)
export default log
